import { of } from 'rxjs';
import { map, mergeAll, filter } from 'rxjs/operators';
import { Action } from '@banking/ui/workflows/balance';
import * as cardListWorkflow from '@banking/ui/workflows/balance/card-list';

// FIXME(steckel): Use TypeScript parameter inference once overloaded functions
// are supported (https://github.com/microsoft/TypeScript/issues/32164)
// import type RouterService from '@ember/routing/router-service';
// type TransitionToArgs = Parameters<RouterService['transitionTo']>;

const navigateToStatements = updates => updates.pipe(filter(([_, action]) => action.type === Action.Type.UserClickStatementsAndDocuments), map(([states, _]) => states[0].unitToken), map(unitToken => ['banking.statements', {
  queryParams: {
    unitToken
  }
}]));
const canNavigateToAdditionalCard = state => (state.doesOwnerHaveNonTerminatedCard || state.allowOwnerOrderAdditionalDebitCards) && state.allowMultipleCards;
const navigateToAdditionalCard = updates => updates.pipe(filter(([[_, after], action]) => action.type === cardListWorkflow.ActionType.UserClickAddDebitCard && canNavigateToAdditionalCard(after.cardListState)), map(([states, _]) => states[0].unitToken), map(unitToken => {
  return ['banking.additional-card', {
    queryParams: {
      unitToken,
      start: 'true'
    }
  }];
}));

// If a seller does not have a card in debit card list, this means that the seller
// does not have their own debit card. We want to send them into onboarding instead
// of additional card flow
const navigateToOnboarding = updates => updates.pipe(filter(([[_, after], action]) => action.type === cardListWorkflow.ActionType.UserClickAddDebitCard && !canNavigateToAdditionalCard(after.cardListState)), map(([states, _]) => states[0].unitToken), map(unitToken => {
  return ['banking.checking', {
    queryParams: {
      unitToken,
      start: 'true'
    }
  }];
}));
const navigateToBillPayHomePage = updates => {
  return updates.pipe(filter(([states, action]) => action.type === Action.Type.UserClickPayBills && states[0].canSeeBillPay), map(([states, _]) => states[0].unitToken), map(unitToken => ['bill-pay-engine.bill-pay.list', {
    queryParams: {
      currentUnitToken: unitToken
    }
  }]));
};
const navigateToBillPayNewBillPage = updates => updates.pipe(filter(([states, action]) => action.type === Action.Type.UserClickUploadBill && states[0].canSeeBillPay), map(([states, _]) => states[0].unitToken), map(unitToken => ['bill-pay-engine.bill-pay.list.new', {
  queryParams: {
    currentUnitToken: unitToken
  }
}]));
const routerTransitions = source => of(...[navigateToStatements, navigateToBillPayHomePage, navigateToBillPayNewBillPage, navigateToAdditionalCard, navigateToOnboarding].map(transition => source.pipe(transition))).pipe(mergeAll());
export default routerTransitions;